import { render, staticRenderFns } from "./MaintenanceItemPrototypeList.vue?vue&type=template&id=733faad0"
import script from "./MaintenanceItemPrototypeList.vue?vue&type=script&lang=ts"
export * from "./MaintenanceItemPrototypeList.vue?vue&type=script&lang=ts"
import style0 from "./MaintenanceItemPrototypeList.vue?vue&type=style&index=0&id=733faad0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports